export const UPLOAD_FILE = "UPLOAD_FILE"
export const UPLOAD_ITEM_FILE = "UPLOAD_ITEM_FILE"
export const REMOVE_FILE = "REMOVE_FILE"
export const API_FAIL = "API_FAIL"
